import React from 'react';
import { Form, Field, Formik, FieldProps } from 'formik';

import { StringOrNull } from 'store/entity/types';
import { enterWithPhone } from 'api/MakhsanApi';
import Button from 'components/Button';
import Input from 'components/Input';
import { display } from 'components/ErrorView/ErrorDialog';
import notify from 'components/Notify';
import { Box } from '../../../utils/style/extendable';
import Icon from '../../../components/Icon';
import i18n from '../../../i18n';

interface IComponentProps {
  issueDate: number;
  loginWithPhoneNumber: (
    loginToken: string,
    codeNumber: string,
    staySignedIn: boolean
  ) => Promise<void>;
  onSubmitPhoneNumber: (phoneNumber: string) => Promise<any>;
  onSubmitVerifySecret: (
    secret: string,
    token: string,
    phoneNumber: string
  ) => Promise<any>;
  phoneNumber?: string;
}

interface IComponentStates {
  changeable: boolean;
  confirmCodeSent: boolean;
  confirmLoading: boolean;
  loading: boolean;
  phoneNumber: string;
  token: StringOrNull;
  loginToken?: string;
}

interface IConfirmCodeFormProps {
  confirmCode: string;
}

class ChangePhoneNumber extends React.PureComponent<
  IComponentProps,
  IComponentStates
> {
  initialCodeValues: IConfirmCodeFormProps = {
    confirmCode: '',
  };

  constructor(props: IComponentProps) {
    super(props);
    this.state = {
      changeable: false,
      confirmCodeSent: false,
      confirmLoading: false,
      loading: false,
      phoneNumber: props.phoneNumber ? props.phoneNumber : '-',
      token: null,
    };
  }

  preparePhoneNumber = (phoneNumber: string) => {
    let phoneNumberVal = phoneNumber;
    while (phoneNumberVal.startsWith('0')) {
      phoneNumberVal = phoneNumberVal.substr(1);
    }
    return `0098${phoneNumberVal}`;
  };

  handleSubmitPhoneNumber = (e: React.FormEvent) => {
    e.preventDefault();
    if (this.props.issueDate + 180000 < Date.now() || this.state.changeable) {
      // confirm current number
      if (this.props.phoneNumber) {
        this.setState({ loading: true });
        const phoneNumber = this.preparePhoneNumber(this.props.phoneNumber);

        enterWithPhone(phoneNumber)
          .then((res) => {
            this.setState({
              loginToken: res.data,
              confirmCodeSent: true,
              loading: false,
            });
          })
          .catch((error) => {
            this.setState({ loading: false });
            display(error);
          });
      } else {
        this.setState({ changeable: true });
      }
    } else {
      // change to new phone number
      this.setState({ loading: true });
      const phoneNumber = this.preparePhoneNumber(this.state.phoneNumber);

      this.props
        .onSubmitPhoneNumber(phoneNumber)
        .then((token: string) => {
          this.setState({ confirmCodeSent: true, loading: false, token });
        })
        .catch((error) => {
          this.setState({ loading: false });
          display(error);
        });
    }
  };

  handleSubmitConfirmCode = (value: IConfirmCodeFormProps) => {
    this.setState({ confirmLoading: true });
    if (this.props.issueDate + 180000 < Date.now() || this.state.changeable) {
      // confirm current number
      this.props
        .loginWithPhoneNumber(
          this.state.loginToken as string,
          value.confirmCode,
          true
        )
        .then(() => {
          this.setState({ confirmCodeSent: false, confirmLoading: false });
        })
        .catch((error) => {
          this.setState({ confirmLoading: false });
          display(error);
        });
    } else {
      // change to new phone number
      const phoneNumber = this.preparePhoneNumber(this.state.phoneNumber);

      this.props
        .onSubmitVerifySecret(
          value.confirmCode,
          this.state.token as string,
          phoneNumber
        )
        .then(() => {
          this.setState({ confirmCodeSent: false, confirmLoading: false });
          notify(i18n.t('phoneNumberChanged', { ns: 'profile' }));
        })
        .catch((error) => {
          this.setState({ confirmLoading: false });
          display(error);
        });
    }
  };

  handleChangePhoneNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ phoneNumber: e.target.value });
  };

  render() {
    return (
      <Box style={{ marginTop: '2rem' }}>
        <h6> {i18n.t('managingPhoneNumber', { ns: 'profile' }) as string}</h6>
        <form onSubmit={this.handleSubmitPhoneNumber}>
          <Input
            name="phoneNumber"
            id="phoneNumber"
            type="text"
            value={this.state.phoneNumber}
            onChange={this.handleChangePhoneNumber}
            label={i18n.t('phoneNumber', { ns: 'profile' }) as string}
            placeholder={
              i18n.t('phoneNumberWithHint', { ns: 'profile' }) as string
            }
            autoComplete="off"
            disabled={
              this.props.issueDate + 180000 < Date.now() ||
              this.state.changeable
            }
          />
          {!this.state.confirmCodeSent && (
            <Button color="green" type="submit" loading={this.state.loading}>
              <Icon
                className="right"
                type="refresh-cw"
                style={{ float: 'right' }}
              />
              {i18n.t('change', { ns: 'profile' }) as string}
            </Button>
          )}
        </form>
        {this.state.confirmCodeSent && (
          <Formik
            initialValues={this.initialCodeValues}
            onSubmit={this.handleSubmitConfirmCode}
          >
            {/*// @ts-expect-error JSX error*/}
            <Form>
              <Field
                name="confirmCode"
                render={({ field }: FieldProps) => (
                  <Input
                    {...field}
                    id="confirmCode"
                    type="text"
                    label={i18n.t('confirmCode', { ns: 'profile' }) as string}
                    placeholder={i18n.t('confirmCode', { ns: 'profile' })}
                    autoComplete="off"
                    style={{ display: 'table' }}
                  />
                )}
              />
              <Button
                color="green"
                type="submit"
                loading={this.state.confirmLoading}
              >
                <Icon
                  className="right"
                  type="save"
                  style={{ float: 'right' }}
                />
                {i18n.t('confirm', { ns: 'profile' }) as string}
              </Button>
            </Form>
          </Formik>
        )}
      </Box>
    );
  }
}
export default ChangePhoneNumber;
